import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import qs from "query-string";
import axios from "axios";
import { authUrl } from "../../product/config/globalVariables";
import PublicWrapper from "../../product/global/homepage/PublicWrapper";
import FeedbackContainer from "../../product/global/homepage/FeedbackContainer";
import {
  TypographyNew,
  TextVariant,
} from "../../product/global/typography/typography";
import Loader from "../../product/global/loader/Loader";
import Topbar from "../topbar/Topbar";

const config = {
  withCredentials: true,
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
};

const VerificationCode: React.FC = () => {
  const history = useHistory();
  const { mail, code } = useParams<{ mail: string; code: string }>();

  const [formState, setFormState] = useState({
    loading: false,
    error: false,
    message: "",
  });

  useEffect(() => {
    const body = {
      email: mail,
      code: code,
    };
    setFormState({ loading: true, error: false, message: "" });

    axios
      .post(authUrl + "/user/verify", qs.stringify(body), config)
      .then(() => {
        setFormState({ loading: true, error: false, message: "" });
        history.push({
          pathname: "/register/password",
          state: body,
        });
      })
      .catch(() => {
        setFormState({
          loading: false,
          error: true,
          message: "Der Acccount konnte nicht verifiziert werden.",
        });
      });
  }, []);

  return (
    <PublicWrapper>
      <Topbar />
      {formState.loading ? <Loader /> : <></>}
      {formState.error ? (
        <FeedbackContainer>
          <TypographyNew variant={TextVariant.subtitle2}>
            {formState.message}
          </TypographyNew>
        </FeedbackContainer>
      ) : (
        <></>
      )}
    </PublicWrapper>
  );
};

export default VerificationCode;
